export default __webpack_public_path__ + "assets/Miner.0a0f.svg";